"use strict";
// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var ClientVideoStreamReceivingReport = /** @class */ (function () {
    function ClientVideoStreamReceivingReport() {
    }
    return ClientVideoStreamReceivingReport;
}());
exports.default = ClientVideoStreamReceivingReport;
//# sourceMappingURL=ClientVideoStreamReceivingReport.js.map